import React from 'react'
import { Tabs, TabsProps } from 'antd'
import { fillColumnStyle } from './pageStyles'

// The pane's own display is left alone: the hidden pane is hidden by its class, which an inline display would override
const fillTabsStyles: TabsProps['styles'] = {
  root: fillColumnStyle,
  body: { height: '100%', display: 'flex', flexDirection: 'column' },
  content: { flex: 1, minHeight: 0 }
}

const paneStyle: React.CSSProperties = { height: '100%', display: 'flex', flexDirection: 'column' }

/**
 * Tabs that pass the height of a `fill` page on to the content of each tab, e.g. an `AutoHeightTable`. Plain Tabs
 * break the flex column, so a table inside them keeps the height it first measured.
 */
const FillTabs: React.FC<Omit<TabsProps, 'styles'>> = ({ items, ...props }) => (
  <Tabs
    {...props}
    styles={fillTabsStyles}
    items={items?.map(item => ({ ...item, children: <div style={paneStyle}>{item.children}</div> }))}
  />
)

export default FillTabs
